<script>
    /**
     * Alert
     */
    import ModalHeader from './ModalHeader.vue';
    import ModalFooter from './ModalFooter';
    import NormalButton from '../widgets/NormalButton.vue';

    export default {
        alias: 'alert',
        defaultOptions () {
            return {
                title: '通知'
            };
        },
        modalCreated (options) {
            for (let key in options) {
                this[key] = options[key];
            }
        },
        data () {
            return {
                title: '',
                text: '',
                btnText: '' || '确定'
            };
        },
        name: 'modal-alert',
        methods: {
            onDestroy () {
                this.okCallback && this.okCallback();
                this.close();
            }
        },
        components: {
            ModalHeader,
            NormalButton,
            ModalFooter
        },
        mounted () {

        }
    };
</script>

<template>
    <div class="normal-modal">
        <modal-header v-html="title" ></modal-header>
        <div class="normal-modal__bd" v-html="text"></div>
        <modal-footer>
            <normal-button @click.native="onDestroy();"
                           theme="primary"
                           :is-modal="true"
            >{{btnText}}</normal-button>
        </modal-footer>
    </div>
</template>

<style lang="less" scoped>

</style>
